declare const google:any;
export class MapSymbols {
  static start: google.maps.Symbol = {
    path: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z',
    fillColor: 'green',
    fillOpacity: 0.9,
    strokeWeight: 0,
    rotation: 0,
    scale: 2.1,
    labelOrigin: { x: 13, y: 10 } as google.maps.Point,
    anchor: { x: 0, y: 24 } as google.maps.Point
  };
  static stop: google.maps.Symbol = {
    path: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z',
    fillColor: 'red',
    fillOpacity: 0.9,
    strokeWeight: 0,
    rotation: 0,
    scale: 2.1,
    labelOrigin: { x: 13, y: 10 } as google.maps.Point,
    anchor: { x: 0, y: 24 } as google.maps.Point
  };
}
